module.exports = __webpack_public_path__ + "static/media/Bedienungsanleitung.901f323e.pdf";